import InlineTextLink from '@/components/inlineTextLink/InlineTextLink';
import type { GlobalFooterStoryblok, PartialLinkStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';
import React from 'react';

import classes from './FooterMeta.module.scss';

const FooterMeta: React.FC<{ blok: GlobalFooterStoryblok; variant?: 'grey' }> = ({ blok, variant }) => {
  return (
    <div className={classNames(classes.meta, classes[variant!])}>
      <div className={classes.content}>
        <div className={classes.copyright}>{blok.copyright}</div>
        <ul className={classes.metaNavigation}>
          {blok.bottom_links.map((listItem: PartialLinkStoryblok, index: number) => (
            <li key={listItem._uid} {...storyblokEditable(listItem)}>
              <InlineTextLink
                data-testid={'footer-links-list-link' + Number(index + 1)}
                link={listItem.link}
                text={listItem.label}
                className={classes.metaLink}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FooterMeta;
